/**
 * PDP product video slider helpers.
 * Video playback lives in yd-video.js; this file only keeps the slider arrows
 * from bubbling clicks into the Swiper slides.
 */

if (!window.YD_PDP_VideoSlider) {
  window.YD_PDP_VideoSlider = {
    initNavigation: function(config) {
      const { rootId, navPrevClass, navNextClass } = config;

      const root = document.getElementById(rootId);
      if (!root) return;

      const prevBtn = root.querySelector(`.${navPrevClass}`);
      const nextBtn = root.querySelector(`.${navNextClass}`);
      if (!prevBtn || !nextBtn) return;

      function stopBubble(event) {
        event.stopPropagation();
      }

      ["click", "pointerup", "touchend", "mouseup", "pointerdown", "touchstart", "mousedown"].forEach((eventName) => {
        prevBtn.addEventListener(eventName, stopBubble, false);
        nextBtn.addEventListener(eventName, stopBubble, false);
      });
    }
  };
}
